export const CHANGE_USER_PASSWORD_REQUEST = 'UPDATE_PROFILE_NO_IMAGE_REQUEST';
export const CHANGE_USER_PASSWORD_SUCCESS = 'UPDATE_PROFILE_NO_IMAGE_SUCCESS';
export const CHANGE_USER_PASSWORD_ERROR = 'UPDATE_PROFILE_NO_IMAGE_ERROR';

export const GET_USER_BALANCE_REQUEST = 'GET_USER_BALANCE_REQUEST';
export const GET_USER_BALANCE_SUCCESS = 'GET_USER_BALANCE_SUCCESS';
export const GET_USER_BALANCE_ERROR = 'GET_USER_BALANCE_ERROR';

export const GET_GAME_VERSION_REQUEST = 'GET_GAME_VERSION_REQUEST';
export const GET_GAME_VERSION_SUCCESS = 'GET_GAME_VERSION_SUCCESS';
export const GET_GAME_VERSION_ERROR = 'GET_GAME_VERSION_ERROR';

export const GET_STATUS_REQUEST = 'GET_STATUS_REQUEST';
export const GET_STATUS_SUCCESS = 'GET_STATUS_SUCCESS';
export const GET_STATUS_ERROR = 'GET_STATUS_ERROR';

export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_ERROR = 'USER_LOGOUT_ERROR';
